import { useCallback, useState } from 'react';
import { useWizard } from 'react-use-wizard';

import { useIsSessionComplete } from '@/features/guided-financial-planning/context';
import { StepLayout } from '@/features/guided-financial-planning/components/step-layout';
import { AccountDetailsSubstep } from './account-details-substep';

export function AssessmentAccountsStep() {
  const { nextStep, previousStep } = useWizard();
  const isSessionComplete = useIsSessionComplete();
  const [accountsComplete, setAccountsComplete] = useState(false);

  const handleAccountsCompleteChange = useCallback((complete: boolean) => {
    setAccountsComplete(complete);
  }, []);

  return (
    <StepLayout
      title="Let's get some details on these accounts"
      subtitle="Click on each account to add the financial details. This helps us accurately project your long-term care coverage capacity."
      nextButtonLabel="Calculate My Coverage"
      isNextDisabled={!accountsComplete}
      onNext={nextStep}
      onBack={previousStep}
    >
      <AccountDetailsSubstep
        onAllCompleteChange={handleAccountsCompleteChange}
        disabled={isSessionComplete}
      />
    </StepLayout>
  );
}
